/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Not sent

1 = Sent / Pending

2 = Declined

3 = Approved

4 = MANUAL_APPROVED

5 = MANUAL_DECLINE

6 = All

7 = Past due

8 = All

9 = Client requested


 */
export type ChangeOrderStatus =
  (typeof ChangeOrderStatus)[keyof typeof ChangeOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeOrderStatus = {
  UNRELEASED: 0,
  PENDING: 1,
  DECLINED: 2,
  APPROVED: 3,
  MANUAL: 4,
  MANUAL_DECLINE: 5,
  ALL: 6,
  EXPIRED: 7,
  ALL_FOR_OWNER: 8,
  OWNER_REQUESTED: 9,
} as const;
